import Vue from 'vue'
import settings from '@/settings.coffee'
import moment from 'moment'

export default {
    get_staff_statslink: (profile_uid, establishment_uid)->
        return """
        query{
            staff_statslink(profil_uid:\"#{profile_uid}\" establishment_uid: \"#{establishment_uid}\")
        }
        """
    get_tag_name: ()->
        return """
        query{
            tag_name
        }
        """
    get_links: ()->
        return """
        query{
            link_set{
                label
                href
                uid
                slug
            }
        }
        """
    get_consultant_links: ()->
        return """
        query{
            consultant_link_set{
                label
                href
                uid
                slug
                icon
            }
        } """
    get_settings: ()->
        return """
        query{
            setting_set{
                slug
                label
                value
                file
                
            }
        }
        """
    get_consultant_stats: (consultant_uid)->
        return """
        query{
          consultant(id:\"#{consultant_uid}\"){
            stats
          }
        }
        """
    get_consultant_stats_fast: (consultant_uid)->
        return """
        query{
          consultant(id:\"#{consultant_uid}\"){
            stats_fast
          }
        }
        """
    get_consultants_stats_from_view: ()->
        return """
        query{
          get_consultants_stats_from_view {
            consultant_id
            consultant_name
            positives_count
            negatives_count
            informationneeded_count
            validated_count
            from_this_morning_count
            from_this_morning_impossible
            from_this_morning_positives_count
            from_this_morning_negatives_count
            from_this_morning_informationneeded_count
            from_this_morning_validated_count         
            today_recived_count
            today_impossible_count
            today_written_count
            today_published_count
            today_signaled_count
            today_information_needed_count
            seven_day_recived_count
            seven_day_impossible_count
            seven_day_written_count
            seven_day_published_count
            seven_day_signaled_count
            seven_day_information_needed_count
            thirty_day_recived_count
            thirty_day_impossible_count
            thirty_day_written_count
            thirty_day_published_count
            thirty_day_signaled_count
            thirty_day_information_needed_count
          }
        }
        """        
    get_sent_notifications_for_establishment: (establishment_uid)->
        return """
        query{
          staff_email_set(
            establishment_uid:\"#{establishment_uid}\"
            ) {
            state {
              review {
                author
                author_url
                created_on
                typo_client
                has_answer
                photo
                link_on_platform
                mark
                platform {
                  name
                  logo
                  logo2
                }
                positive
                published_on
                scrap_id
                scraped_on
                text_fr
                text_native
                title_fr
                title_native
                uid
                native_lang {
                  code
                }
                nb_message
                updated_on
                current_state{
                    class_name
                    active
                    data
                    uid
                    verbose_name
                }
                answerer{
                    uid lastname firstname fullname
                }
                establishment {
                    name
                    uid
                    logo
                }                
              }
              uid
            }
            sent_on
          }
        }
        """
    get_reviews_to_process: (establishment_uid)->
        gql_query = """
        query{
          reviews_to_process
          """
        if establishment_uid?
            gql_query += "(establishment_uid:\"#{establishment_uid}\")"
        gql_query += """
            {
                author
                author_url
                created_on
                link_on_platform
                mark
                title_fr
                title_native
                text_fr
                text_native
                positive
                published_on
                scrap_id
                scraped_on
                uid
                nb_message
                updated_on
                journey_date
                photo
                establishment_scrap_url_type {
                  name
                }
                platform {
                  name
                  logo
                  logo2
                }                
                native_lang {
                  code
                }                
                current_state{
                    class_name
                    active
                    data
                    uid
                    verbose_name
                }
                answerer{
                    uid lastname firstname fullname
                }
                establishment {
                    name
                    uid
                    logo
                }
              }
        }
        """
        return gql_query                
    get_review_done_set: (establishment_uid)->
        gql_query = """
        query{
          review_done_set
          """
        if establishment_uid?
            gql_query += "(establishment_uid:\"#{establishment_uid}\")"
        gql_query += """
            {
                author
                author_url
                created_on
                link_on_platform
                mark
                title_fr
                title_native
                text_fr
                text_native
                positive
                published_on
                scrap_id
                scraped_on
                uid
                nb_message
                updated_on
                journey_date
                photo
                establishment_scrap_url_type {
                  name
                }
                platform {
                  name
                  logo
                  logo2
                }                
                native_lang {
                  code
                }                
                current_state{
                    class_name
                    active
                    data
                    uid
                    verbose_name
                }
                answerer{
                    uid lastname firstname fullname
                }
                establishment {
                    name
                    uid
                    logo
                }
              }
        }
        """
        return gql_query
    get_all_message_for_review: (review_uid)->
        return """
        query{
          all_message_review(review_uid:\"#{review_uid}\"){
            messages{
              who
              text
              posted_on
              avatar
            }
          }
        }
        """
    get_review_message_and_answer: (review_uid)->
        return """
        query{
          review_details(review_uid:\"#{review_uid}\"){
            answer_text
            message_text
          }
        }
        """
    get_review_details: (review_uid)->
        return """
        query{
          review_details(review_uid:\"#{review_uid}\"){
            scraped_on
            conseil_chambre
            note_rapport_qp
            note_emplacement
            note_service
            note_chambre
            note_proprete
            note_literie
            note_cuisine
            note_service_resto
            note_ambiance_resto
            note_confort
            note_restauration
            sollicite
            point_fort
            commentaire_deta_inter
            commentaire_plat_boisson
            commentaire_accessibilite
            commentaire_securite
            commentaire_acti_proxi
            commentaire_chambres
            commentaire_vegetarien
            commentaire_restrict_alim
            commentaire_enfants
            commentaire_accessibilite_pmr
            commentaire_conseil_parking
            lieu_repas
            type_repas
            prix_repas
            plat_reco
            place_parking
            option_statio
            sur_mobile
            platform{
                name
                logo
                logo2
            }
          }
        }
        """
    get_review_content: (review_uid)->
        return """
        query{
          review_content(review_uid:\"#{review_uid}\"){
            text_fr
            text_native
            text_signaling
          }
        }
        """
    get_sent_notifications_for_user: ()->
        return """
        query{
          staff_email_set {
            state {
              review {
                author
                author_url
                created_on
                link_on_platform
                mark
                platform {
                  name
                  logo
                  logo2
                }
                positive
                published_on
                scrap_id
                scraped_on
                text_fr
                text_native
                title_fr
                title_native
                uid
                native_lang {
                  code
                }
                nb_message
                updated_on
                current_state{
                    class_name
                    active
                    data
                    uid
                    verbose_name
                }
                answerer{
                    uid lastname firstname fullname
                }
                establishment {
                    name
                    uid
                    logo
                }
              }
              uid
            }
            sent_on
          }
        }
        """
    get_staff_establishment: (staff_uid)->
        return """
        query{
          establishment_staff(id:\"#{staff_uid}\") {
            establishment {
              logo
              main_picture
              name
              uid
              report_set(published:true){
                uid
                period_start
                period_end
              }
            }
            avatar
            fullname
            firstname
            uid
          }
        }
        """
    get_gathering_from_staff: (staff_uid)->
        return """
        query{
          get_gathering_form_staff(staff_uid:\"#{staff_uid}\") {
            uid
            name
            logo
            consultant {
               uid
               avatar
               firstname
               lastname
               email
               phone                    
            }
          }
        }
        """
    get_gathering_establishments: (gathering_uid)->
        return """
        query{
          gathering_staff(id:\"#{gathering_uid}\") {
            gathering{
              establishment_set {
                logo
                main_picture
                name
                uid
                report_set(published:true){
                  uid
                  period_start
                  period_end
                }
              }
            }
            avatar
            fullname
            firstname
            uid
          }
        }
        """
    gql_query_get_review_lang: (state_uid)->
        return """
        query{
          state(id:\"#{state_uid}\"){
            review{
              native_lang {
                code
                name
                translation_cost_per_word
                uid
              }
            }
          }
        }
        """
#    get_establishment_validators: (establishment_uid)->
#      return """
#      query {
#        establishment(id:\"#{establishment_uid}\") {
#          validators {
#            name
#            uid
#            staff_type
#          }
#        }
#      }
#      """
    gql_review_can_be_used_as_logos_example: (uid)->
      return """
        query{review_can_be_used_as_logos_example(uid:\"#{uid}\") {
          can_use_as_example,
          use_as_logos_example
        }}
      """
    get_review_detail_for_establishment: (uid)->
        return """
        query {
          review(id:\"#{uid}\"){
            author
            author_url
            typo_client
            link_on_platform
            mark
            positive
            published_on
            text_fr
            text_native
            title_fr
            title_native
            uid
            photo
            has_answer
            typo_client
            current_state {
              uid
              created_on
              data
              class_name
              verbose_name
              active
              list_actions {
                slug
                name
                groups
              }
            }
            native_lang {
                code
                uid
            }
            establishment {
              uid
              name
              consultant {
                firstname
              }
              logo
              main_picture
            }
            platform {
              uid
              name
            }
          }
        }
        """
    gql_query_review_detail: (uid)->
        return """
        query {
          review(id:\"#{uid}\"){
            author
            author_url
            pays
            typo_client
            type_heberg
            photo
            nbr_nuits
            journey_date
            has_answer
            created_on
            link_on_platform
            mark
            positive
            published_on
            scrap_id
            scraped_on
            text_fr
            use_as_logos_example
            text_native
            title_fr
            title_native
            uid
            updated_on
            has_game_set
            answerer{
              uid lastname firstname fullname
            }
            current_state {
              created_on
              data
              verbose_name
            }
            native_lang {
                code
                uid
            }
            game_set {
              uid
              answer1 {
                uid
              }
              answer2 {
                uid
              }
              best_answer {
                uid
              }
            }
            state_set {
              class_name
              created_on
              data
              uid
              updated_on
              active
              verbose_name
              email_action {
                  template_slug
                  template_uid
              }
              list_actions {
                slug
                name
                groups
              }
              review {
                uid
              }
            }
            establishment {
              created_on
              name
              notes
              scrap_id
              uid
              updated_on
              website
              page_reseau_public
              logo
              page_reseau_public_2

              gathering {
                uid
              }
              signature_set {
                  title
                  language {
                      code
                  }
                  content
              }
            }
            platform {
              created_on
              link_to_home
              link_to_login
              name
              slug
              logo
              logo2
              uid
              updated_on
            }
          }
        }
        """
    gql_report_detail: (uid)->
        return """
        query{establishment_report(id:\"#{uid}\"){
            uid generated_text
        }}
        """
    get_connection_for: (platform_uid, establishment_uid)->
        return """
        query{connection_set(
            establishment__uid:\"#{establishment_uid}\",
            platform__uid:\"#{platform_uid}\"){
            uid,login,password,uid,info,establishment_link,platform{name}
        }}
        """
    get_connection_for_review: (review_uid)->
        return """
        query{connection_set_for_review(
            review_uid:\"#{review_uid}\")}
        """        
    gql_query_answer_set: (review_uid)->
        return """
        query{
          answer_set(review:\"#{review_uid}\")
            {
              uid
              answer_text
              created_on
              updated_on
              score_human_global_note
              score_human_style_respect
              score_human_answers_diversity
              score_human_review_context
              score_human_marketing
              score_human_no_hallucinations
              score_human_comments
            }
        }
        """
    gql_review_scores_progress: (review_uid)->
        return """
        query{review_scores_progress(uid:\"#{review_uid}\") {
          answers_with_scores,
          total_answers_for_etab_and_sentiment,
          scores_progress_ratio
        }}
        """
    get_next_report_text: (establishement_uid)->
        start = moment().format("YYYY-MM-01")
        return """
        query{establishment_report_set(
            establishment__uid:\"#{establishement_uid}\",
            period_start:\"#{start}\"
        ){uid, custom_text}}
        """
    get_translation_cost: (lang_uid, text)->
        return """
        query{translation_cost(lang_uid:\"#{lang_uid}\", text:\"#{text}\") {
          cost
        }}
  
        """
    get_langs: ()->
        return """
        query{lang_set{
          name
          uid
        }}
  
        """
    get_staff_establishments: (staff_uuid)->
        return """
        query{
            get_staff_establishments(staff_uid:\"#{staff_uuid}\"){
                logo
                main_picture
                name
                uid
                stats_average_mark
                nb_negative
                nb_positive
                nb_infoneeded
                nb_signaling
                nb_answerwriting
                report_set(published:true){
                  uid
                  period_start
                  period_end
                }
                consultant{
                  uid
                  avatar
                  firstname
                  lastname
                  email
                  phone
                }
            }
        }
        """
    get_staff_roles: (staff_uid)->
        return """
        query{
          get_staff_roles(staff_uid:\"#{staff_uid}\"){
            notify_info_needed
            report_access
            text_role
            uid
            establishment{
              uid
            }
          }
        }
        """
    named_state_set: ()->
        return """
        query{
          named_state_set{
            name, value
          }
        }
        """
    query_stat_team: ()->
        return """
        query{
          stats_team
        }
        """
    get_mail_templates_from_state: (state_uid)->
        return """
        query{
          email_template_set_from_state(state_uid: "#{state_uid}") {
            uid, subject
          }
        }        
        """
    get_importreport_set: (offset)->
        if not offset
            offset = 0
        return """
        query{
          importreport_set(offset: #{offset}) {
            uid,
            started_at,
            data_source_engine,
            filename,
            errors_count,
            created_count,
            modified_count,
            existing_count,
            errors_count_clean,
            nb_warning
          }
        }
        """        
    get_importreportline_set: (report_uid)->
        return """
        query{
          importreportline_set(import_report: "#{report_uid}") {
              level
              platform
              title
          }
        }
        """        
    get_last_review_by_platform: (report_uid)->
        return """
        query{
          last_review_by_platform {
              created_on
              platform {
                  name
                  slug
              }
          }
        }
        """
    get_assistants_list: ()-> 
        return """
        query{
          assistants_list{
            uid
            is_affected
            name
            is_active 
            specialist_sentiment
            specialist_platform_id
            elo_global
            created_on
            created_by {
              username
            }
            step_set {
              uid
              llm_name
              temperature
              max_output_tokens
              max_input_tokens
              search_examples
              example_choice_strategy
              example_selection_strategy
              example_fill_strategy
              example_fixed_n
              prompt
            }
            affectation_set {
              establishment {
                uid
                name
                }
            }
          }
        }
        """
      get_platform_set: ()->
        return """
        query {
          platform_set {
            uid
            name
          }
        }
        """
      get_establishment_set: ()->
        return """
        query {
          establishment_set {
            uid
            name
          }
        }
        """
      get_available_llms: ()-> 
        return """
        query{
          available_llms{
            name
            infos
            max_tokens
            max_input_tokens
            max_output_tokens
            input_cost_per_token
            output_cost_per_token
            litellm_provider
            mode
            supported_openai_params
          }
        }
        """
      get_default_prompt: ()->
        return """
        query{
            default_prompt{
              prompt
            }
          }
        """
      get_assistant_list_fields:() ->
        return """
        uid
        name
        specialist_sentiment
        elo_score
        specialist_platform {
              uid
              name
            }
        created_on
        is_active
        is_affected
        created_by {
          username
        }
        step_set {
          llm_name
          temperature
          example_choice_strategy
          example_selection_strategy
          example_fill_strategy
        }
        """
      get_assistant_detail_list_fields:() ->
        return """
            uid
            is_affected
            name
            is_active 
            specialist_sentiment
            elo_score
            specialist_platform {
              uid
              name
            }
            created_on
            created_by {
              username
            }
            step_set {
              uid
              step_index
              llm_name
              temperature
              max_output_tokens
              max_input_tokens
              search_examples
              example_choice_strategy
              example_selection_strategy
              example_fill_strategy
              example_fixed_n
              prompt
            }
            affectation_set {
              establishment {
                uid
                name
                }
            }
        """
    get_establishment_types: ()->
      return """
      query{
        establishment_types{
        name
        }
      }
      """
    assistants: (kwargs=null) ->
      filters = []
      if !kwargs?
        # console.log("KKKWARGS", kwargs)
        return """
        query{
          assistants {
            #{@get_assistant_list_fields()}
          }
        }
        """
      # console.log(kwargs)

      if kwargs.uid?
        fields = @get_assistant_detail_list_fields()
        filters.push """uid: "#{kwargs.uid}"
        """
      else
        fields = @get_assistant_list_fields()


      if kwargs.sentiment?
        filters.push """sentiment: "#{kwargs.sentiment}"
        """

      if kwargs.platform_id?
        filters.push """platform_id: "#{kwargs.platform_id}"
        """

      if kwargs.establishment_id?
        filters.push """establishment_id: "#{kwargs.establishment_id}"
        """

      if kwargs.establishment_type?
        filters.push """establishment_type: "#{kwargs.establishment_type}"
        """

      filters_string = if filters.length > 0 then "(" + filters.join(", ") + ")" else ""

      return """
      query{
        assistants#{filters_string} {
          #{fields}
        }
      }
      """
    run_v2: (query_key, kwargs...) ->
      if kwargs.length is 1
        # console.log(kwargs.length)

        # console.log("kwargs: ", kwargs)
        q = @[query_key](kwargs...)
      else
        # console.log(query_key)
        q = @[query_key]()

      
      # console.log(q)
      return Vue.http.post(settings.graphqlApiUrl, {"query": q})

    get_fields_label: (model)->
        return """
        query{
          fields_label_set(model: "#{model}") {
              name
              verbose_name
              help_text
          }
        }
        """
    run: (query_key, args)->
        q = this[query_key].apply(null, args)

        # console.log(q)

        return Vue.http.post(settings.graphqlApiUrl, {"query": q})
}
